import { AppRouteProps } from "@bsm/component";
import React from "react";

const AboutStudentDetailsContainer = React.lazy(() => import('./containers/AboutStudentDetailsContainer'))
export const AboutUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'about',
        title: '{{StudentNameDetailsTab}}',
        element: <AboutStudentDetailsContainer />
    }
]